import "./frontend_config";
import React from "react";
import ReactDOM from "react-dom";
import "@near-wallet-selector/modal-ui/styles.css";
import "@near-wallet-selector/account-export/styles.css";

import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
